import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { Session } from './session';

import { SessionType } from '../types';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

const _schema = {
    name: 'FCM',
    fields: [
        { name: 'created', type: 'date', volatile: true },
        { name: 'session', type: 'objid' },
        { name: 'lang', type: 'string', default: 'EN' },
        { name: 'token', type: 'string' },
    ],
    relate: [
        { direction: '>', target: 'SESSION', by: 'session', name: 'session', reason: 'session', child: false, class: SessionType },
    ],
} as const;

const _FCMClass = CreateObject(_schema);
if (!_FCMClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class FCM extends _FCMClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null) {
        super(_schema, objid, data, objoptions || {});

        if (!this.created){
            this.created = new Date();
        }
    }

    Copy(store: Array<DataObject> = []): FCM {
        return this._Copy(store) as FCM;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf){
            return;
        }

        if (relation === 'session' && related instanceof Session){
            if (related === this.session){
                related.AddFcm(this);
            }
            else {
                related.DelFcm(this);
            }
        }
    }
}
